var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main-dashboard"},_vm._l((_vm.dashboard),function(item){return _c('div',{key:item.title,staticClass:"flex",on:{"click":function($event){return _vm.gotoPage(item.route)}}},[_c('link-card',{staticClass:"card-style",attrs:{"item":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }